import { SET_PATIENT_ID,SET_SLIDE,SET_CHAT_COUNT,SET_DIET_COUNT} from "./Action";


const initialState = {
    sidebarShow: true,
    patientId:"",
    chatCount:"",
    dietCount:""
  };

  const reducer=(state=initialState,{type,payload})=>{
    switch (type){
        case SET_PATIENT_ID:
            return{ ...state, patientId: payload };
        case SET_SLIDE:
            return{ ...state, sidebarShow: payload };
        case SET_CHAT_COUNT:
            return{ ...state, chatCount: payload };
        case SET_DIET_COUNT:
            return{ ...state, dietCount: payload };
        default:
            return state;
    }
  }


  export default reducer